const {Component} = Shopware;

import template from './reci-setting.html.twig'

Component.override('sw-system-config', {
    template
});